<script>
  import favoriteImages from "./favoriteImages";

  export let goToDesignTool;
  export let chooseFavoriteImage;

  export let favoriteImageIndex;
  let currentImageIndex = 1;

  $: leftImage = favoriteImages[favoriteImageIndex];
  $: rightImage = favoriteImages[currentImageIndex];

  function chooseLeftImage() {
    currentImageIndex += 1;
    if (currentImageIndex >= favoriteImages.length) {
      goToDesignTool();
    }
  }

  function chooseRightImage() {
    chooseFavoriteImage(currentImageIndex);
    currentImageIndex += 1;
    if (currentImageIndex >= favoriteImages.length) {
      goToDesignTool();
    }
  }
</script>

<main>
  <p>Which image best suits your personality?</p>
  <p>Step {currentImageIndex}</p>
  <div class="flex">
    <div class="image">
      <img src={leftImage} alt="" />
      <button on:click={chooseLeftImage}>This is more me</button>
    </div>
    <div class="image">
      <img src={rightImage} alt="" />
      <button on:click={chooseRightImage}>This is more me</button>
    </div>
  </div>
</main>

<style>
  main {
    background: #f0f0f0;
  }
  p {
    color: #020202;
    font-size: 2, 5em;
    font-weight: 100;
  }
  .flex {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
  }
  .image {
    width: 200px;
    height: 200px;
  }
</style>
